import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { avoidFavorStatsSchema } from '../schemas/avoid-favor-stats.schema';

/**
 * Gets avoid favor stats
 * @returns Avoid favor stats
 */
export function getDashboardAvoidFavorStats(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(this).dashboardAvoidFavorStatsUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(avoidFavorStatsSchema));
}
